module.exports = __webpack_public_path__ + "static/media/iPhone-X-Mockup-inside.f2b38757.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/roi/iPhone-X-Mockup-inside.png
// module id = 3310
// module chunks = 0